export default {
  "mainVegetable": "zelenina",
  "mainVegetable/01": "zelenina/baklazan",
  "mainVegetable/02": "zelenina/spargla",
  "mainVegetable/03": "zelenina/avokado",
  "mainVegetable/04": "zelenina/repa",
  "mainVegetable/05": "zelenina/brokolica",
  "mainVegetable/06": "zelenina/mrkva",
  "mainVegetable/07": "zelenina/zeler",
  "mainVegetable/08": "zelenina/huby",
  "mainVegetable/09": "zelenina/kapusta",
  "mainVegetable/10": "zelenina/ruzickovy-kel",
  "mainVegetable/11": "zelenina/cinska-kapusta",
  "mainVegetable/12": "zelenina/karfiol",
  "mainVegetable/13": "zelenina/kapustovy-salat",
  "mainVegetable/14": "zelenina/uhorka",
  "mainVegetable/15": "zelenina/cuketa",
  "mainVegetable/16": "zelenina/cakanka",
  "mainVegetable/17": "zelenina/spenat",
  "mainVegetable/18": "zelenina/fazula-fava",
  "mainVegetable/19": "zelenina/fazule-francuzske",
  "mainVegetable/20": "zelenina/fazule-francuzske",
  "mainVegetable/21": "zelenina/fazule-suche",
  "mainVegetable/22": "zelenina/fazule-zelene",
  "mainVegetable/23": "zelenina/sosovka",
  "mainVegetable/24": "zelenina/zeleninovu-zmes",
  "mainVegetable/25": "zelenina/kukurica",
  "mainVegetable/26": "zelenina/salatovy-mix",
  "mainVegetable/27": "zelenina/kalerab",
  "mainVegetable/28": "zelenina/cibula",
  "mainVegetable/29": "zelenina/soja",
  "mainVegetable/30": "zelenina/paprika",
  "mainVegetable/31": "zelenina/zemiaky",
  "mainVegetable/32": "zelenina/klicky-sojovych-bobov",
  "mainVegetable/33": "zelenina/redkovky",
  "mainVegetable/34": "zelenina/salat-dubovy-listovy",
  "mainVegetable/35": "zelenina/salat-kuceravy",
  "mainVegetable/36": "zelenina/salat-ladovy",
  "mainVegetable/37": "zelenina/salat-zemiakovy",
  "mainVegetable/38": "zelenina/salat-ryzovy",
  "mainVegetable/39": "zelenina/salat-rimsky",
  "mainVegetable/40": "zelenina/zelene-vyhonky",
  "mainVegetable/41": "zelenina/salat",
  "mainVegetable/42": "zelenina/valerianka-polna",
  "mainVegetable/43": "zelenina/rukola",
  "mainVegetable/44": "zelenina/cierny-koren",
  "mainVegetable/45": "zelenina/tabouleh",
  "mainVegetable/46": "zelenina/paradajka",
  "mainVegetable/47": "zelenina/fazule-maslovy",
  "mainVegetable/48": "zelenina/cicer",
  "mainVegetable/49": "zelenina/por",
  "mainVegetable/50": "zelenina/tekvica",
  "mainVegetable/51": "zelenina/fazula-cervene",
  "mainVegetable/52": "zelenina/jablko",
  "mainVegetable/53": "zelenina/gastan",
  "mainVegetable/54": "zelenina/slivka",
  "mainVegetable/55": "zelenina/giardiniera",
  "mainVegetable/56": "zelenina/cierne-olivy",
  "mainVegetable/57": "zelenina/articoky",
  "mainVegetable/58": "zelenina/paprika-cervena",
  "mainVegetable/59": "zelenina/fazule-zelena",
  "mainVegetable/60": "zelenina/jarna-zelenina",
  "mainVegetable/61": "zelenina/ratatouille",
  "mainVegetable/62": "zelenina/kuskus",
  "mainVegetable/63": "zelenina/tazin",
  "mainVegetable/64": "zelenina/kari-zelenina",
  "mainVegetable/65": "zelenina/hrachovej-salky",
  "mainVegetable/66": "zelenina",
  "mainVegetable/67": "zelenina/sosovka-koralova",
  "mainVegetable/68": "zelenina/quinoa",
  "mainVegetable/69": "zelenina/psenica-spaldova",
  "mainVegetable/70": "zelenina/bulgur",
  "mainVegetable/71": "zelenina/kapusta-cervena",
  "mainVegetable/72": "zelenina/kalerab-kuceravy",
  "mainVegetable/73": "zelenina/trebulka",
  "mainVegetable/74": "zelenina/obilia-a-semena",
  "mainVegetable/75": "zelenina/strukoviny",
  "mainVegetable/76": "zelenina/dioskorea",
  "mainVegetable/77": "zelenina/tekvica",
  "mainVegetable/78": "zelenina/stiavu",
  "mainVegetable/79": "zelenina/fazula",
  "mainVegetable/80": "zelenina/hrachova-mrkva",
  "mainVegetable/81": "zelenina/hrasok",
  "mainVegetable/82": "zelenina/edamame",
  "mainVegetable/83": "zelenina/jacmen",
  "mainVegetable/84": "zelenina/salatove-mix",
  "mainVegetable/85": "zelenina/cakanka-cukrova",
  "mainVegetable/86": "zelenina/valerianka-polna",
  "mainVegetable/87": "zelenina/spenat-baby",
  "mainVegetable/88": "zelenina/salat-batavia",
  "mainVegetable/89": "zelenina/mangold",
  "mainVegetable/90": "zelenina",
  "mainVegetable/91": "zelenina",
  "mainVegetable/92": "zelenina",
  "mainVegetable/93": "zelenina",
  "mainVegetable/94": "zelenina",
  "mainVegetable/95": "zelenina",
  "mainVegetable/96": "zelenina",
  "mainVegetable/97": "zelenina",
  "mainVegetable/98": "zelenina",
  "productRange": "rozsah",
  "productRange/4G_BIO": "rozsah",
  "productRange/4G_SRP": "rozsah",
  "productRange/CAN_A_POEL": "rozsah",
  "productRange/CAN_SEC_BI": "rozsah",
  "productRange/CAN_SEC_CO": "rozsah",
  "productRange/CAN_SEC_CU": "rozsah",
  "productRange/CAN_SEC_NA": "rozsah",
  "productRange/CAN_VAPEUR": "rozsah",
  "productRange/CAN_VEG_SA": "rozsah",
  "productRange/CAN_VEG_SR": "rozsah",
  "productRange/CLASSICVEG": "rozsah",
  "productRange/COLDVEGE": "rozsah",
  "productRange/COOKMUSH": "rozsah",
  "productRange/CRUDITES": "rozsah",
  "productRange/DE_NOS_PRO": "rozsah",
  "productRange/DOYMUSHACC": "rozsah",
  "productRange/DOYMUSHAPE": "rozsah",
  "productRange/DRYVEGE": "rozsah",
  "productRange/FROZENVEGE": "rozsah",
  "productRange/FRZ_ASTUCE": "rozsah",
  "productRange/FRZ_GRATIN": "rozsah",
  "productRange/FRZ_KELLO": "rozsah",
  "productRange/FRZ_LEG_CO": "rozsah",
  "productRange/FRZ_PUREES": "rozsah",
  "productRange/FRZ_VEG_BI": "rozsah",
  "productRange/FRZ_VEG_SR": "rozsah",
  "productRange/INDFROZVEG": "rozsah",
  "productRange/JEUNES_POU": "rozsah",
  "productRange/LAITUES": "rozsah",
  "productRange/LOOP": "rozsah",
  "productRange/LUNCH_BOWL": "rozsah",
  "productRange/MACHE_BASE": "rozsah",
  "productRange/MEL_LAITUE": "rozsah",
  "productRange/MUSHNATEMI": "rozsah",
  "productRange/MUSHNATENT": "rozsah",
  "productRange/MUSHNATEPA": "rozsah",
  "productRange/MUSHNATMIN": "rozsah",
  "productRange/MUSHROOMS": "rozsah",
  "productRange/SUNVEGE": "rozsah",
  "productRange/TRAIT_CRUD": "rozsah",
  "productRange/TRAIT_TABO": "rozsah",
  "productRange/TUS_RECETA": "rozsah",
  "productRange/WORLDVEGE": "rozsah",
  "productRange/PREPARED_VEG": "rozsah",
  "productRange/BEAN_SAUCE": "rozsah/bon-menu",
  "productRange/BEANS": "rozsah",
  "productRange/BIO": "rozsah",
  "productRange/BOND_KIDS": "rozsah",
  "productRange/CAN_BIO": "rozsah",
  "productRange/CAN_SEC_PR": "rozsah",
  "productRange/CARTA_DELL": "rozsah",
  "productRange/CAN_PETITS": "rozsah",
  "productRange/CAN_BOCAL": "rozsah",
  "productRange/CEREAL_CAN": "rozsah",
  "productRange/CEREAL_FRZ": "rozsah",
  "productRange/CEREALI": "rozsah",
  "productRange/CEREALLEGR": "rozsah",
  "productRange/COCCOLE": "rozsah",
  "productRange/CORN": "rozsah/zlata-kukurica",
  "productRange/CREATIF": "rozsah/creatif",
  "productRange/FRANCAIS": "rozsah",
  "productRange/FRZ_FRY_MI": "rozsah",
  "productRange/FRZ_MELANG": "rozsah",
  "productRange/FRZ_POELEE": "rozsah",
  "productRange/INSALATE_D": "rozsah",
  "productRange/INSALATONA": "rozsah",
  "productRange/LE_REGIONA": "rozsah",
  "productRange/LEGUMIO": "rozsah/legumio",
  "productRange/MIXES_CORN": "rozsah",
  "productRange/MONO_VEGE": "rozsah",
  "productRange/MUSHROOMS  ": "rozsah/sampinony",
  "productRange/NATURA_IN": "rozsah",
  "productRange/OTHER_VEG": "rozsah/ostatne",
  "productRange/PEAS": "rozsah/hrasok",
  "productRange/READY_FROZ": "rozsah/hotove-jedla",
  "productRange/SOUPS": "rozsah/polievkove-zmesi",
  "productRange/SPINACH": "rozsah",
  "productRange/STEAM_CAN": "rozsah/vapeur",
  "productRange/STEAM_FRZ": "rozsah",
  "productRange/STEAM_MIX": "rozsah",
  "productRange/STUZZICHIA": "rozsah",
  "productRange/TOUCHE": "rozsah/mini",
  "productRange/TRAIT_SAL": "rozsah",
  "productRange/TUS_RECETA ": "rozsah",
  "productRange/VEG_TO_FRY": "rozsah",
  "productRange/VEGGIE": "rozsah",
  "productRange/FRZ_JUSTEA": "rozsah",
  "productRange/SALABIS": "rozsah",
  "productRange/BON_SENGAG": "rozsah",
  "productRange/CROUSTIS": "rozsah",
  "season": "sezona",
  "season/1": "sezona/leto",
  "season/2": "sezona/jesen",
  "season/3": "sezona/zima",
  "season/4": "sezona/jar",
  "season/5": "sezona",
  "technologie": "technologia",
  "technologie/AC01": "technologia/sterilizovane",
  "technologie/AD01": "technologia/zmrazene",
  "technologie/AG01": "technologia/cerstve",
  "technologie/AT01": "technologia",
  "recipeDish": "typ-pokrmu",
  "recipeDish/ACC": "typ-pokrmu/medzi-chody",
  "recipeDish/APE": "typ-pokrmu/aperetiv",
  "recipeDish/DES": "typ-pokrmu/dezert",
  "recipeDish/ENT": "typ-pokrmu/predkrm",
  "recipeDish/PLAT": "typ-pokrmu/hlavne-jiedlo",
  "recipeDish/SAL": "typ-pokrmu/salat",
  "recipeDish/SNA": "typ-pokrmu/desiata",
  "recipeDish/PDE": "typ-pokrmu/ranajky",
  "recipeDish/DEJ": "typ-pokrmu/obed",
  "recipeDish/TRA": "typ-pokrmu/tradicni",
  "recipeDish/GOU": "typ-pokrmu/delikatesa",
  "recipeDish/ETH": "typ-pokrmu/kulturne",
  "recipeDish/FCH": "typ-pokrmu/pre-deti",
  "recipeDish/SOU": "typ-pokrmu",
  "pred-recipeTimingCook-facet": "doba-vareni",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "doba-vareni/0-15-minut",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "doba-vareni/15-30-minut",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "doba-vareni/30-45-minut",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "doba-vareni/45-minut",
  "pred-recipeTimingPreparation-facet": "dobra-pripravy",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "dobra-pripravy/0-15-minut",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "dobra-pripravy/15-30-minut",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "dobra-pripravy/30-45-minut",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "dobra-pripravy/45-minut",
  "pred-recipeCost-Facet": "rozpocet",
  "pred-recipeCost-Facet/petit": "rozpocet/lacne",
  "pred-recipeCost-Facet/moyen": "rozpocet/drahsie",
  "pred-recipeCost-Facet/grand": "rozpocet/drahe",
  "recipeDifficulty": "zlozitost",
  "recipeDifficulty/1": "zlozitost/jednoducha",
  "recipeDifficulty/2": "zlozitost/stredne-pokrocilych",
  "recipeDifficulty/3": "zlozitost/narocne",
  "recipeDishNumber": "pocet-hostov",
  "recipeDishNumber/1": "pocet-hostov/1",
  "recipeDishNumber/2": "pocet-hostov/2",
  "recipeDishNumber/3": "pocet-hostov/3",
  "recipeDishNumber/4": "pocet-hostov/4",
  "recipeDishNumber/5": "pocet-hostov/5",
  "recipeDishNumber/6": "pocet-hostov/6",
  "recipeDishNumber/7": "pocet-hostov/7",
  "recipeDishNumber/8": "pocet-hostov/8",
  "productTheme": "vyrobok",
  "productTheme/ACC": "vyrobok/priloha",
  "productTheme/BEA": "vyrobok/fazula",
  "productTheme/BIS": "vyrobok/fazula-s-omackou",
  "productTheme/BIO": "vyrobok/bio",
  "productTheme/CAN": "vyrobok/konzerva",
  "productTheme/CER": "vyrobok",
  "productTheme/CLS": "vyrobok/tradicne",
  "productTheme/DLE": "vyrobok/zelenina",
  "productTheme/EDR": "vyrobok/dochucovadlo",
  "productTheme/ENT": "vyrobok/predkrm",
  "productTheme/FRZ": "vyrobok/mrazeny",
  "productTheme/FSD": "vyrobok/salaty",
  "productTheme/FSH": "vyrobok",
  "productTheme/ING": "vyrobok/prisada-pre-moje-recepty",
  "productTheme/JAR": "vyrobok",
  "productTheme/LBW": "vyrobok",
  "productTheme/LDF": "vyrobok/zelenina-v-trube",
  "productTheme/LEG": "vyrobok/lusteniny",
  "productTheme/LGO": "vyrobok/legumio",
  "productTheme/LGR": "vyrobok/grilovana-zelenina",
  "productTheme/LGS": "vyrobok",
  "productTheme/MAI": "vyrobok",
  "productTheme/MUS": "vyrobok/sampinony",
  "productTheme/NEW": "vyrobok/nove-produkty",
  "productTheme/PDH": "vyrobok/susena-zelenina-na-tanieri",
  "productTheme/PDL": "vyrobok/kosik-zeleniny",
  "productTheme/PHR": "vyrobok/cestoviny",
  "productTheme/PLP": "vyrobok",
  "productTheme/RAL": "vyrobok/ryza-a-zelenina",
  "productTheme/RDM": "vyrobok/kuchynske-taniere",
  "productTheme/SAL": "vyrobok/vse-pro-mojich-salatov",
  "productTheme/SDB": "vyrobok/salatove-misy",
  "productTheme/SNK": "vyrobok/desiata",
  "productTheme/SUP": "vyrobok/polievky",
  "productTheme/TEX": "vyrobok/mexicka",
  "productTheme/VGP": "vyrobok/rostlinne-produkty",
  "recipeTheme": "tematicke-recepty",
  "recipeTheme/01": "tematicke-recepty/slavnostne-recepty",
  "recipeTheme/02": "tematicke-recepty/aperitiv",
  "recipeTheme/03": "tematicke-recepty/salaty-a-desiata",
  "recipeTheme/04": "tematicke-recepty/polievky-a-kremy",
  "recipeTheme/05": "tematicke-recepty/kis-a-zapecane-recepty",
  "recipeTheme/06": "tematicke-recepty/specialne-pre-deti",
  "recipeTheme/07": "tematicke-recepty/dezerty",
  "recipeTheme/08": "tematicke-recepty/vegetarianske",
  "recipeTheme/09": "tematicke-recepty/priloha",
  "recipeTheme/10": "tematicke-recepty/rychlovka",
  "recipeTheme/11": "tematicke-recepty/varene",
  "recipeTheme/12": "tematicke-recepty/salaty-a-barbecue",
  "recipeTheme/13": "tematicke-recepty/lahke-obcarstvenie",
  "recipeTheme/14": "tematicke-recepty",
  "recipeTheme/15": "tematicke-recepty/zakusky-a-pecivo",
  "recipeTheme/16": "tematicke-recepty",
  "recipeTheme/17": "tematicke-recepty/salaty",
  "recipeTheme/18": "tematicke-recepty/misy",
  "recipeTheme/19": "tematicke-recepty/polievka",
  "recipeTheme/20": "tematicke-recepty/desiata",
  "recipeTheme/21": "tematicke-recepty/omacka",
  "recipeTheme/22": "tematicke-recepty/jednochodove",
  "recipeTheme/23": "tematicke-recepty/viacechodove",
  "recipeTheme/24": "tematicke-recepty/pecene",
  "recipeTheme/25": "tematicke-recepty",
  "recipeTheme/26": "tematicke-recepty",
  "recipeTheme/27": "tematicke-recepty",
  "recipeTheme/28": "tematicke-recepty",
  "recipeTheme/33": "tematicke-recepty",
  "recipeTheme/34": "tematicke-recepty",
  "recipeTheme/35": "tematicke-recepty",
  "recipeTheme/36": "tematicke-recepty",
  "recipeTheme/37": "tematicke-recepty",
  "recipeTheme/38": "tematicke-recepty",
  "recipeTheme/39": "tematicke-recepty",
  "recipeTheme/40": "tematicke-recepty",
  "recipeTheme/41": "tematicke-recepty",
  "recipeTheme/42": "tematicke-recepty",
  "recipeTheme/43": "tematicke-recepty",
  "recipeTheme/44": "tematicke-recepty",
  "recipeTheme/45": "tematicke-recepty",
  "recipeTheme/46": "tematicke-recepty",
  "pred-particularite": "recipe-habits",
  "pred-particularite/Sans%20conservateur": "food-habits/bez-konzervantov",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "food-habits",
  "pred-particularite/Sans%20colorant": "food-habits/bez-barviva",
  "pred-particularite/Sans%20sucre%20ajout%E9": "food-habits/bez-pridaneho-cukru",
  "pred-particularite/Sans%20sel%20ajout%E9": "food-habits/bez-pridanej-soli",
  "pred-particularite/Sans%20additif": "food-habits/bez-prisad",
  "pred-particularite/": "food-habits/s-prirodnou-soli",
  "pred-particularite/Sans%20lactose": "food-habits/bez-laktozy",
  "pred-particularite/Sans%20gluten": "food-habits/bez-lepku",
  "pred-particularite/V%E9g%E9tarien": "food-habits/vegetarianske",
  "pred-particularite/V%E9g%E9talien": "food-habits/veganske",
  "pred-particularite/Sans%20sulfite": "food-habits",
  "pred-particularite/A%20la%20vapeur": "food-habits",
  "pred-particularite/Sans%20condiment": "food-habits",
  "cultureType": "typ-of-kultury",
  "cultureType/Bio": "typ-of-kultury/bio",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "typ-of-kultury/bez-pesticidov",
  "cultureType/Sans%20OGM": "typ-of-kultury/bez-gmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "recipe-habits/vegansky",
  "pred-particularite/recipeVeggie": "recipe-habits/vegetariansky",
  "pred-particularite/recipeGlutenfree": "recipe-habits/bez-lepku",
  "pred-particularite/recipeLactosefree": "recipe-habits/bez-laktozy"
};
